<template>
  <!-- // 报表钻取明细 -->
  <div class="app-container" id="xsjmxList">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="统计年份" prop="jcnf">
          <el-date-picker
            ref="jcnf"
            v-model="queryParams.jcnf"
            type="year"
            :clearable="false"
            value-format="yyyy"
            placeholder="选择年"
            size="small"
            style="width: 185px"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="queryParams.bmbh"
            placeholder="所属部门"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeBm"
            multiple
            collapse-tags
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="项目状态" prop="xmzt">
          <el-select
            ref="xmzt"
            v-model="queryParams.xmzt"
            placeholder="项目状态"
            filterable
            multiple
            collapse-tags
            size="small"
            style="width: 185px"
            class="filter-item"
            @change="handleChangeHtzt"
          >
            <el-option
              v-for="item in htztList"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="项目名称" prop="xmbh">
          <el-select
            ref="xmbh"
            v-model="queryParams.xmbh"
            placeholder="项目名称"
            filterable
            size="small"
            style="width: 185px"
            class="filter-item"
          >
            <el-option
              v-for="item in xmList"
              :key="item.xmbh"
              :label="item.xmjc"
              :value="item.xmbh"
            />
          </el-select>
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            style="margin-right: 10px"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-download"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class="xmmc">{{ queryParams.xmmc }}</div>
    <div>
      <div>
        <el-table
          v-loading="listLoading"
          :data="xsjmcList.list"
          fit
          :header-cell-style="tableHeaderColor"
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
          :max-height="height"
          class="xsjmxTable"
        >
          <el-table-column
            label="序号"
            prop="zbid"
            min-width="50px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="评价指标"
            prop="pjzb"
            min-width="100px"
            :show-overflow-tooltip="true"
            fixed
            align="center"
          ></el-table-column>
          <el-table-column
            label="指标名称"
            prop="zbmc"
            min-width="170px"
            :show-overflow-tooltip="true"
            fixed
            align="center"
          ></el-table-column>
          <el-table-column
            label="指标描述"
            prop="zbkj"
            min-width="100px"
            :show-overflow-tooltip="true"
            align="center"
            fixed
          ></el-table-column>
          <el-table-column
            label="1月"
            prop="yf1"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf1.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf1.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf1, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf1.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf1.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="2月"
            prop="yf2"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf2.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf2.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf2, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf2.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf2.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="3月"
            prop="yf3"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf3.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf3.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf3, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf3.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf3.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="4月"
            prop="yf4"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf4.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf4.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf4, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf4.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf4.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="5月"
            prop="yf5"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf5.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf5.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf5, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf5.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf5.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="6月"
            prop="yf6"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf6.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf6.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf6, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf6.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf6.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="7月"
            prop="yf7"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf7.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf7.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf7, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf7.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf7.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="8月"
            prop="yf8"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf8.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf8.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf8, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf8.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf8.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="9月"
            prop="yf9"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf9.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf9.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf9, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf9.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf9.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="10月"
            prop="yf10"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf10.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf10.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf10, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf10.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf10.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="11月"
            prop="yf11"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf11.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf11.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf11, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf11.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf11.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            label="12月"
            prop="yf12"
            min-width="100px"
            align="center"
            class="month"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
                :open-delay="500"
                :disabled="!scope.row.yf12.zxjg"
              >
                <div slot="content">
                  <span style="margin-right: 10px">
                    <el-button
                      size="mini"
                      plain
                      @click="handleToView(scope.row.yf12.rzList)"
                      >查看</el-button
                    >
                  </span>
                  <span>
                    <el-button
                      size="mini"
                      plain
                      @click="handleToEdit(scope.row.yf12, scope.row.zbmc)"
                      v-if="canEdit"
                      >编辑</el-button
                    >
                  </span>
                </div>
                <div
                  :style="{
                    background:
                      scope.row.yf12.zxjg == 1
                        ? '#70B603'
                        : scope.row.yf12.zxjg == 2
                        ? '#D9001B'
                        : '#D7D7D7',
                  }"
                >
                  <span> {{ "" }}</span>
                </div>
              </el-tooltip>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <pagination
          v-show="xsjmcList.total > 0"
          :total="xsjmcList.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList"
        />
      </div>
    </div>
    <el-dialog
      :title="`查看详情_${viewList[0].zbmc}`"
      :visible.sync="viewDialog"
      width="800px"
      :closeOnClickModal="false"
      v-if="viewDialog"
      class="viewDialog"
    >
      <el-table
        :data="viewList"
        fit
        highlight-current-row
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
        <el-table-column
          label="时间"
          align="center"
          prop="sj"
          :show-overflow-tooltip="true"
          min-width="100px"
        />
        <el-table-column
          label="更新类型"
          align="center"
          prop="gxlx"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
        <el-table-column
          label="变更前"
          align="center"
          prop="czqjg"
          :show-overflow-tooltip="true"
          min-width="50px"
        >
        </el-table-column>
        <el-table-column
          label="变更后"
          align="center"
          prop="czhjg"
          :show-overflow-tooltip="true"
          min-width="50px"
        >
        </el-table-column>

        <el-table-column
          label="更新说明"
          align="center"
          prop="gxsm"
          :show-overflow-tooltip="true"
          min-width="150px"
        >
        </el-table-column>
        <el-table-column
          label="操作人"
          align="center"
          prop="czr"
          :show-overflow-tooltip="true"
          min-width="80px"
        >
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      title="编辑"
      :visible.sync="editDialog"
      width="600px"
      :closeOnClickModal="false"
      v-if="editDialog"
      class="editDialog"
    >
      <div>
        <el-form
          ref="editForm"
          label-width="100px"
          :model="editForm"
          :hide-required-asterisk="false"
          style="margin-top: 15px"
          :rules="editRules"
        >
          <el-form-item label="指标名称：" prop="zbmc">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.zbmc"
              size="small"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="所属月份：" prop="yf">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.yf"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="当前结果：" prop="czqjg">
            <el-select
              ref="status"
              v-model="editForm.czqjg"
              placeholder="修改结果"
              filterable
              size="small"
              style="width: 100%"
              class="filter-item"
              disabled
            >
              <el-option
                v-for="item in zxjgList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="修改结果：" prop="czhjg">
            <el-select
              ref="status"
              v-model="editForm.czhjg"
              placeholder="修改结果"
              filterable
              size="small"
              style="width: 100%"
              class="filter-item"
            >
              <el-option
                v-for="item in zxjgList"
                :key="item.dictValue"
                :label="item.dictLabel"
                :value="item.dictValue"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="调整说明：" prop="gxsm">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.gxsm"
              size="small"
              type="textarea"
              :rows="5"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作人：" prop="czr">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.czr"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item label="操作时间：" prop="czsj">
            <el-input
              show-word-limit
              placeholder=""
              v-model="editForm.czsj"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editDialog = false" size="smalll">
            取消
          </el-button>
          <el-button type="primary" size="smalll" @click="handleEditResult()">
            确定
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import Pagination from "@/components/Pagination";
import { mapGetters } from "vuex";
import moment from "moment";
import {
  getInspecMxList,
  updateXjjg,
  xmCheckAuthor,
  exportInspecMxList,
} from "@/api/xmcheck.js";

import { getBmxxList } from "@/api/itWeekly.js";
import { addExportFileDate } from "@/utils/utils";
import { getDict, getXmxxList } from "@/api/common";
export default {
  // 列表分页
  name: "xsjmxList",
  components: { Pagination },
  computed: {
    ...mapGetters(["user"]),
  },
  data() {
    return {
      pickerOptions: {
        disabledDate: (time) => {
          let oldDate = new Date("2023-12-31T12:00:00.000Z");
          let oneYear = new Date(oldDate).getTime();
          return time.getTime() < oneYear;
        },
      },
      height: 800,
      listLoading: false,
      xsjmcList: {
        list: [],
        total: 0,
      },
      queryParams: {
        page: 1,
        pageSize: 10,
        jcnf: moment().format("YYYY"),
        bmbh: "",
        xmbh: "243",
        xmmc: "",
        xmzt: "",
      },
      viewDialog: false,
      viewList: [],

      editDialog: false,
      editForm: {},
      editRules: {
        czhjg: [
          { required: true, message: "请选择修改后的结果", trigger: "blur" },
        ],
        gxsm: [{ required: true, message: "请输入调整说明", trigger: "blur" }],
      },
      bmList: [],
      htztList: [],
      xmList: [],
      zxjgList: [],
      canEdit: false,
      storageXmbh: "",
    };
  },

  mounted() {
    this.startWatching();
  },
  created() {
    if (sessionStorage.getItem("lineCheckDetailParams")) {
      this.queryParams = {
        ...this.queryParams,
        ...JSON.parse(sessionStorage.getItem("lineCheckDetailParams")),
      };
      this.queryParams.xmbh = +this.queryParams.xmbh;
      this.storageXmbh = this.queryParams.xmbh;
      this.queryParams.xmzt = ["" + this.queryParams.xmzt];
      this.queryParams.bmbh = [this.queryParams.bmbh];
    }
    this.getList();
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    getBmxxList("2", "1").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
        // this.queryParams.bmbh = [this.bmList[0].bmbh];
      }
    });
    getDict("xmgl_xmzt", "2").then((res) => {
      if (res.code == 0) {
        this.htztList = res.data;
        // if (sessionStorage.getItem("lineCheckDetailParams")) {
        // } else {
        //   this.queryParams.xmzt = [res.data[0].dictValue];
        // }
        this.getXmxxListFun(true);
      }
    });
    getDict("pmp_xmxj_zxjg").then((res) => {
      if (res.code == 0) {
        this.zxjgList = res.data;
      }
    });
  },
  methods: {
    getList() {
      const { xmbh, jcnf } = this.queryParams;

      const data = {
        xmbh,
        jcnf,
      };

      getInspecMxList(data).then((response) => {
        const docH = document.documentElement.clientHeight;
        const mycontainerH =
          document.querySelector(".mycontainer").clientHeight;
        this.height = docH - mycontainerH - 70;
        this.loading = false;
        if (response.code === 0) {
          this.xsjmcList.list = response.data;
          if (this.xsjmcList.list && this.xsjmcList.list.length > 0) {
            this.queryParams.xmmc = this.xsjmcList?.list[0].xmmc;
            this.getPermision();
          }
        } else {
          this.$message({
            showClose: true,
            message: response.msg,
            type: "error",
            duration: 2000,
            center: true,
          });
        }
      });
    },
    getXmxxListFun(isFirst) {
      getXmxxList({
        xmlx: "DS",
        type: "2",
        range: "1",
        xmzt: this.queryParams.xmzt.join(","),
        bmbh: this.queryParams.bmbh.join(","),
      }).then((res) => {
        if (res.code == 0) {
          this.xmList = res.data;
          if (!isFirst) {
            this.queryParams.xmbh = this.xmList[0].xmbh;
            // this.queryParams.xmmc = this.xmList[0].xmjc;
          }

          // this.getList();
        }
      });
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
    handleToView(row) {
      this.viewList = row;
      if (row && row.length > 0) {
        this.viewDialog = true;
      } else {
        this.$message.info("暂无数据");
      }
    },
    handleToEdit(row, zbmc) {
      this.editDialog = true;
      this.editForm = {};
      this.editForm.czsj = moment().format("YYYYMMDD");
      this.editForm.czr = this.user.xm;
      this.editForm.yf = row.yf;
      this.editForm.zbmc = zbmc;
      this.editForm.czqjg = row.zxjg;
      this.editForm.jgid = row.id;
    },
    handleEditResult() {
      const { jgid, czqjg, czhjg, gxsm } = this.editForm;
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          updateXjjg({ jgid, czqjg, czhjg, gxsm }).then((res) => {
            if (res.code == 0) {
              this.$message.success(res.msg);
              this.editDialog = false;
              this.editForm = {};
              this.getList();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
    handleChangeHtzt(i) {
      this.queryParams.xmzt = i;
      this.getXmxxListFun();
    },
    handleChangeBm(i) {
      this.queryParams.bmbh = i;
      this.getXmxxListFun();
    },
    handleExport() {
      const { xmbh, jcnf } = this.queryParams;

      const data = {
        xmbh,
        jcnf,
      };
      exportInspecMxList(data).then((res) => {
        if (res.code === 0) {
          let fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          fileName = addExportFileDate(fileName);

          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
    getPermision() {
      xmCheckAuthor({ xmbh: this.queryParams.xmbh }).then((res) => {
        if (res.code == 0) {
          if (res.data && (res.data.manage == 1)) {
            this.canEdit = true;
          } else {
            this.canEdit = false;
          }
        }
      });
    },
    startWatching() {
      setInterval(() => {
        const currentStorage =
          JSON.parse(sessionStorage.getItem("lineCheckDetailParams")) || {};
        if (this.storageXmbh != currentStorage.xmbh) {
          location.reload();
        }
      }, 1000);
    },
  },
};
</script>
  <style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 0;
}
.back {
  display: inline-block;
  background-color: #ffba01;
  height: 32px;
  width: 48px;
  line-height: 32px;
  text-align: center;
  color: #fff;
  border-radius: 5px;
  cursor: pointer;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
.xmmc {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: 700;
}
</style>

